<template>
    <div class="input-file" :class="{ hasError: v.$error }">
        <svg class="icon">
            <use xlink:href="#file"/>
        </svg>
        <input
            type="file"
            class="input-file__text"
            multiple
            accept="image/x-png, image/gif, image/jpeg, image/jpg, application/pdf"
            :id="fileInputName"
            :name="fileInputName"
            :placeholder="placeholder"
            @change="$emit('input', $event.target.files)"
            ref="inputFile"/>
        <label class="input-file__label" :for="fileInputName">{{ placeholder }}</label>
        <span class="input__error" v-if="v.$error">{{ errorText }}</span>
    </div>
</template>

<script>
export default {
    name: "inputFile",
    props: {
        value: {
          type: FileList
        },
        v: {
            type: Object,
            required: true,
        },
        fileInputName: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "Добавить изображение"
        },
        errorText: {
            type: String,
            default: "Максимальный размер прикрепляемых файлов 20Мб"
        }
    },
    mounted() {
        this.$watch('value', () => {this.$refs.inputFile.files = this.value;});

        let inputs = document.querySelectorAll('.input-file__text');
        Array.prototype.forEach.call(inputs, function (input) {
            let label = input.nextElementSibling;
            input.addEventListener('change', function (e) {
                let countFiles = '';
                countFiles = this.files.length;
                if (countFiles >= 1) {
                    label.innerText = 'Выбрано файлов: ' + countFiles;
                }
            });
        });
    }
}
</script>
